import { render, staticRenderFns } from "./FocusKeywords.vue?vue&type=template&id=aa5d36c0&scoped=true&"
import script from "./FocusKeywords.vue?vue&type=script&lang=js&"
export * from "./FocusKeywords.vue?vue&type=script&lang=js&"
import style0 from "./FocusKeywords.vue?vue&type=style&index=0&id=aa5d36c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d36c0",
  null
  
)

export default component.exports